import { ethers } from 'ethers'
import { NftContract } from './NftContract'

/**
 * Domain class for a blockchain
 *
 * Don't instantiate this class directly, import from `ChainProvider` instead.
 */
export class Chain {
  private memoizedProvider?: ethers.providers.StaticJsonRpcProvider
  private privateKey?: string

  constructor (
    public readonly id: number,
    public readonly name: string,
    public readonly publicRpcUri: string,
    public readonly trophyverseContract: NftContract,
    public readonly cardContract: NftContract,
    public readonly collectionContract?: NftContract
  ) {
    this.privateKey = process.env.PRIVATE_KEY
    this.id = id
    this.name = name
    this.publicRpcUri = publicRpcUri
    this.trophyverseContract = trophyverseContract
    this.cardContract = cardContract
    this.collectionContract = collectionContract
  }

  public getProvider (rpcUri: string): ethers.providers.StaticJsonRpcProvider {
    if (this.memoizedProvider === undefined) {
      this.memoizedProvider = new ethers.providers.StaticJsonRpcProvider(rpcUri)
    }

    return this.memoizedProvider
  }

  public getSigner (rpcUri: string): ethers.Signer {
    const provider = this.getProvider(rpcUri)

    if (this.privateKey) {
      return new ethers.Wallet(this.privateKey, provider)
    }

    return provider.getSigner()
  }
}
